function runSlider_3() {
  var swiper = new Swiper(".product-collection", {
    mode: "horizontal",
    loop: false,
    resizeReInit: true,
    autoHeight: false,
    scrollContainer: true,
    grabCursor: true,
    createPagination: false,
    preventClicks: true,
    freeMode: false,
    slidesPerView: 4,
    dynamicBullets: false,
    spaceBetween: 0,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      481: {
        slidesPerView: 2,
      },
      990: {
        slidesPerView: 3,
      },
      1500: {
        slidesPerView: 4,
      },
    },
  });
}

$(function () {
  var isHomapage = $("body").hasClass("enableslider");
  if (isHomapage ) {
    runSlider_3();
  }
});

$(document).on(
  "shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect",
  function () {
    runSlider_3();
  }
);

function blog_slider() {
  var swiper = new Swiper(".blog-collection", {
    mode: "horizontal",
    loop: false,
    resizeReInit: true,
    autoHeight: false,
    scrollContainer: true,
    grabCursor: true,
    createPagination: false,
    preventClicks: true,
    freeMode: false,
    // freeModeFluid: false,
    slidesPerView: 4,
    dynamicBullets: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
     navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      481: {
        slidesPerView: 2,
      },
      990: {
        slidesPerView: 3,
      },
      1500: {
        slidesPerView: 4,
      },
    },
  });
}
$(function () {
  var isHomapage = $("body").hasClass("enableslider");
  if (isHomapage) {
    blog_slider();
  }
});

// Run on theme customizer - Homepage blog slider
$(document).on(
  "shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect",
  function () {
    blog_slider();
  }
);

function testimonial_slider() {
  let tesswiper2 = new Swiper(".testimonial-slider-thumb", {
    mode: "horizontal",
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 8,
    freeMode: true,
    
  });
  let tesswiper = new Swiper(".testimonial-slider", {
    mode: "horizontal",
    loop: true,
    resizeReInit: true,
    autoHeight: false,
    scrollContainer: true,
    grabCursor: true,
    preventClicks: true,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
        swiper: tesswiper2,
    },
  });  
}
$(function () {
  let isHomapage = $("body").hasClass("enableslider");
  if (isHomapage) {
    testimonial_slider();
  }
});

// Run on theme customizer - Homepage testimonial slider
$(document).on(
  "shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect",
  function () {
    testimonial_slider();
  }
);

function feature_slider() {
  var swiper = new Swiper(".features-list", {
    mode: "horizontal",
    loop: false,
    resizeReInit: true,
    autoHeight: false,
    scrollContainer: true,
    grabCursor: true,
    createPagination: false,
    preventClicks: true,
    freeMode: false,
    // freeModeFluid: false,
    slidesPerView: 5,
    dynamicBullets: false,
    spaceBetween: 24,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      481: {
        slidesPerView: 2,
      },
      750: {
        slidesPerView: 3,
      },
      990: {
        slidesPerView: 4,
      },
      1500: {
        slidesPerView: 5,
      },
    },
  });
}
$(function () {
  var isHomapage = $("body").hasClass("enableslider");
  if (isHomapage) {
    feature_slider();
  }
});

// Run on theme customizer - Feature Slider
$(document).on(
  "shopify:section:load shopify:section:unload shopify:section:select shopify:section:deselect",
  function () {
    feature_slider();
  }
);


function headerTransparent() {
  const header = document.querySelector(".section-header");
  if (header) {
    const headerHeight = header.offsetHeight;
    if (document.body.classList.contains("header-transparent")) {
      header.style.marginBottom = `-${headerHeight}px`;
    }
  }
}
window.addEventListener("load", headerTransparent);
window.addEventListener("resize", headerTransparent);

// Blog Post Load More Button 

document.addEventListener('DOMContentLoaded', function() {
  var loadMoreBtn = document.getElementById('load-more');

  loadMoreBtn.addEventListener('click', function() {
    var nextPage = loadMoreBtn.getAttribute('data-page');
    var nextPageUrl = loadMoreBtn.getAttribute('data-url');

    fetch(nextPageUrl)
      .then(response => response.text())
      .then(data => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data, 'text/html');
        var newArticles = doc.querySelectorAll('#article-list .article-item');
        var newNextPageUrl = doc.querySelector('#load-more')?.getAttribute('data-url');

        if (newArticles.length > 0) {
          newArticles.forEach(function(article) {
            document.getElementById('article-list').appendChild(article);
          });

          // Update the data-url attribute for the next page
          if (newNextPageUrl) {
            loadMoreBtn.setAttribute('data-url', newNextPageUrl);
            loadMoreBtn.setAttribute('data-page', parseInt(nextPage) + 1);
          } else {
            // No more pages to load, hide the button
            loadMoreBtn.style.display = 'none';
          }
        } else {
          // No more articles to load, hide the button
          loadMoreBtn.style.display = 'none';
        }

        // Change the opacity and visibility of elements with the class 'dish-image bdReveal'
        var dishImages = document.querySelectorAll('.dish-image.bdReveal');
        dishImages.forEach(function(image) {
          image.style.opacity = '1';
          image.style.visibility = 'visible';
          image.style.transform = 'translateY(0)';
        });
         var dishImages = document.querySelectorAll('.content-detail.bdReveal');
        dishImages.forEach(function(image) {
          image.style.opacity = '1';
          image.style.visibility = 'visible';
          image.style.transform = 'translateY(0)';
        });
      })
      .catch(error => console.error('Error loading more articles:', error));
  });
});


$(document).ready(function(){
  $(".faq-wrap li h6").click(function(){
    let currentLi = $(this).closest("li");
    if (currentLi.hasClass("active")) {
      currentLi.removeClass("active");
      currentLi.find(".faq-content").slideUp();
    } else {
      $(".faq-wrap").find("li").removeClass("active");
      $(".faq-wrap").find(".faq-content").slideUp();
      currentLi.addClass("active");
      $(this).next(".faq-content").slideDown();
    }
  });

  $(".recipes-tabs-content .recipes-list:not(:first-child)").hide();
  $(".recipes-tabs li").click(function(){
    var target = $(this).attr("data-href");
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    $(".recipes-list").fadeOut(300, function() {
        $(target).fadeIn(300);
    });
  });
});

// Whats Included slider
  let swiper;

  function initMobileSwiper() {
    const width = window.innerWidth;

    if (width <= 749 && !swiper) {
      swiper = new Swiper(".includ-section .mySwiper", {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev",
        },
        breakpoints: {
          481: {
            slidesPerView: 2,
          },
        },
      });
    } else if (width > 749 && swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
  }

  document.querySelectorAll('.split-first-word').forEach((el) => {
    const text = el.textContent.trim();
  
    if (text.startsWith('Bertha ') || text.startsWith('bertha ') || text.startsWith('BERTHA ')) {
      const firstSpace = text.indexOf(' ');
      const firstWord = text.slice(0, firstSpace);
      const rest = text.slice(firstSpace + 1);
  
      el.innerHTML = `<span class="first-word">${firstWord}</span> ${rest}`;
    }
  });

  document.querySelectorAll('.split-first-word-any').forEach((el) => {
    const text = el.textContent.trim();
    const firstSpace = text.indexOf(' ');
  
    if (firstSpace > -1) {
      const firstWord = text.slice(0, firstSpace);
      const rest = text.slice(firstSpace + 1);
      el.innerHTML = `<span class="first-word">${firstWord}</span> ${rest}`;
    }
  });

  window.addEventListener("load", initMobileSwiper);
  window.addEventListener("resize", initMobileSwiper);

